import { LanguageType } from '@nx-smartmonkey/shared/domain';

import EnFlag from '../../../assets/img/admin-translations/en_flag.svg';
import EsFlag from '../../../assets/img/admin-translations/es_flag.svg';
import PtFlag from '../../../assets/img/admin-translations/pt_flag.svg';

export const getFlagByLocale = (language: LanguageType) => {
  switch (language) {
    case `es`:
      return EsFlag;
    case `en`:
      return EnFlag;
    case `pt`:
      return PtFlag;
    default:
      return ``;
  }
};
